var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 390.93 308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-miterlimit:10;}.cls-1{stroke:#1e1c55;stroke-width:8px;}.cls-2{stroke:#ff1c3b;stroke-linecap:round;stroke-width:2px;stroke-dasharray:4 4;}.cls-3{fill:#18184c;}.cls-4{opacity:0.3;}.cls-5{fill:#1e1c55;}.cls-6{fill:#ff1c3b;}.cls-7{fill:#212121;}.cls-8{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Badge1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Badge"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Badge1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.54,304A150,150,0,0,1,137.15,15.79,150,150,0,0,1,253.93,292.21,149.14,149.14,0,0,1,195.54,304Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.54,291.5A137.53,137.53,0,0,1,142,27.31a137.53,137.53,0,0,1,107,253.38A136.72,136.72,0,0,1,195.54,291.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "308 256.68 373.29 275.33 366.67 240.05 390.93 213.59 325.65 194.94 308 256.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M308,256.68l16.31.24a10.9,10.9,0,0,0,10.63-7.9l.62-2.17-22.88-6.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "83.49 257.09 18.46 276.61 24.6 241.24 0 215.11 65.03 195.59 83.49 257.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.49,257.09l-16.3.46a10.91,10.91,0,0,1-10.74-7.76l-.65-2.16,22.8-6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M335.2,248.49a452,452,0,0,0-279.31,0Q46,218,36.05,187.43a516,516,0,0,1,319,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "198 60.73 176.61 60.73 176.61 67.03 187.31 67.03 187.31 67.85 187.31 94.16 195.04 94.16 195.04 67.85 195.04 67.03 198 67.03 198 94.16 205.74 94.16 205.74 67.03 205.74 60.73 198 60.73"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 198,
    y: 52.02,
    width: 7.74,
    height: 6.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M110.41,118.41H103.7v-4H122v4h-6.72v17h-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.16,131.55v3.9H124.9v-21h15.87v3.9h-11v4.56h9.75v3.78h-9.75v4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M144,125c0-6.33,4.86-10.86,11.4-10.86a10.84,10.84,0,0,1,8.64,3.72l-3.12,2.88a6.76,6.76,0,0,0-5.28-2.46,6.72,6.72,0,0,0,0,13.44,6.69,6.69,0,0,0,5.28-2.49l3.12,2.88a10.79,10.79,0,0,1-8.67,3.75C148.81,135.81,144,131.28,144,125Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M186.82,114.45v21H182v-8.61h-9.54v8.61h-4.86v-21h4.86v8.28H182v-8.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M192.1,114.45H197v21H192.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M221.35,135.45l0-12.6-6.18,10.38H213l-6.15-10.11v12.33h-4.56v-21h4l7.86,13,7.74-13h4l.06,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M249.4,122.07c0,4.68-3.51,7.59-9.12,7.59h-4.23v5.79h-4.86v-21h9.09C245.89,114.45,249.4,117.36,249.4,122.07Zm-4.92,0c0-2.31-1.5-3.66-4.47-3.66h-4v7.29h4C243,125.7,244.48,124.35,244.48,122.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.15,114.45H258v17h10.53v4H253.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M279.49,128v7.44h-4.86V128l-8.13-13.5h5.16l5.61,9.33,5.61-9.33h4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M141.77,258.51a3,3,0,0,1-1.87.56,2.55,2.55,0,0,1-2.86-2.8v-4h-1.37v-1.56H137v-1.89h2v1.89h2.22v1.56H139v4c0,.81.4,1.24,1.15,1.24a1.79,1.79,0,0,0,1.09-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M151,255.43h-6.51a2.5,2.5,0,0,0,2.69,2,3,3,0,0,0,2.25-.9l1,1.2a4.19,4.19,0,0,1-3.34,1.35c-2.79,0-4.59-1.79-4.59-4.26a4.13,4.13,0,0,1,4.29-4.24,4,4,0,0,1,4.2,4.29C151.05,255,151,255.25,151,255.43Zm-6.53-1.29h4.71a2.26,2.26,0,0,0-2.35-2A2.29,2.29,0,0,0,144.49,254.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M152.39,254.81a4.19,4.19,0,0,1,4.49-4.24,3.72,3.72,0,0,1,3.54,1.93l-1.49.87a2.33,2.33,0,0,0-2.07-1.15,2.6,2.6,0,0,0,0,5.19,2.35,2.35,0,0,0,2.07-1.15l1.49.87a3.76,3.76,0,0,1-3.54,1.94A4.21,4.21,0,0,1,152.39,254.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M170.36,254.21V259h-1.94v-4.5c0-1.48-.74-2.2-2-2.2a2.21,2.21,0,0,0-2.32,2.51V259h-1.94V247.43h1.94v4.19a3.72,3.72,0,0,1,2.77-1.05C168.88,250.57,170.36,251.7,170.36,254.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M172.72,248.13A1.18,1.18,0,0,1,174,247a1.16,1.16,0,0,1,1.25,1.12,1.2,1.2,0,0,1-1.25,1.21A1.18,1.18,0,0,1,172.72,248.13Zm.26,2.53h2V259h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M191.52,254.21V259h-2v-4.5c0-1.48-.68-2.2-1.86-2.2s-2.16.84-2.16,2.49V259h-2v-4.5c0-1.48-.68-2.2-1.86-2.2s-2.16.84-2.16,2.49V259h-2v-8.3h1.85v1.06a3.43,3.43,0,0,1,2.72-1.15A3.1,3.1,0,0,1,185,252a3.89,3.89,0,0,1,3.11-1.38C190.12,250.57,191.52,251.7,191.52,254.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M203,254.81a4,4,0,0,1-4.21,4.26A3.42,3.42,0,0,1,196.1,258v4h-1.94V250.66H196v1.09a3.42,3.42,0,0,1,2.75-1.18A4,4,0,0,1,203,254.81Zm-2,0a2.47,2.47,0,1,0-2.46,2.6A2.41,2.41,0,0,0,201,254.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M205,247.43h1.94V259H205Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M217.4,250.66l-3.89,9c-.76,1.88-1.82,2.46-3.2,2.46a3.43,3.43,0,0,1-2.22-.76l.77-1.43a2.17,2.17,0,0,0,1.43.57c.69,0,1.09-.32,1.47-1.15l.14-.32-3.63-8.34h2l2.62,6.14,2.62-6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M217.6,257.78a1.28,1.28,0,1,1,2.55,0,1.28,1.28,0,1,1-2.55,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M221.36,254.81a4.2,4.2,0,0,1,4.5-4.24,3.74,3.74,0,0,1,3.54,1.93l-1.49.87a2.34,2.34,0,0,0-2.07-1.15,2.6,2.6,0,0,0,0,5.19,2.37,2.37,0,0,0,2.07-1.15l1.49.87a3.78,3.78,0,0,1-3.54,1.94A4.22,4.22,0,0,1,221.36,254.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M230.43,254.81a4.42,4.42,0,1,1,4.41,4.26A4.17,4.17,0,0,1,230.43,254.81Zm6.88,0a2.47,2.47,0,1,0-2.47,2.6A2.41,2.41,0,0,0,237.31,254.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M255.18,254.21V259h-2v-4.5c0-1.48-.68-2.2-1.86-2.2s-2.16.84-2.16,2.49V259h-2v-4.5c0-1.48-.68-2.2-1.86-2.2s-2.16.84-2.16,2.49V259h-2v-8.3h1.85v1.06a3.43,3.43,0,0,1,2.72-1.15,3.1,3.1,0,0,1,2.8,1.38,3.89,3.89,0,0,1,3.11-1.38C253.78,250.57,255.18,251.7,255.18,254.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M61.75,194.56l-4.43,1c-.23-1-.35-1.47-.58-2.44,4.83-1.17,7.25-1.72,12.11-2.78l.53,2.46c-1.77.39-2.66.58-4.43,1,1,4.22,1.43,6.34,2.39,10.56l-3.14.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M70.92,196.76c-.84-3.87,1.76-7.45,6.16-8.35s8.19,1.36,8.94,5.28-1.9,7.38-6.18,8.25S71.76,200.64,70.92,196.76Zm11.86-2.45a4.41,4.41,0,1,0-3.47,5.05A4.17,4.17,0,0,0,82.78,194.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M100.14,189.33c.48,2.93-1.52,5.13-5.21,5.78l-2.77.49.65,3.62-3.16.58c-1-5.25-1.47-7.88-2.44-13.13,2.42-.45,3.63-.67,6.06-1.09C97,184.93,99.66,186.37,100.14,189.33Zm-3.26.54c-.24-1.45-1.39-2.12-3.36-1.78l-2.63.47.82,4.56,2.61-.46C96.28,192.31,97.13,191.3,96.88,189.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M107.65,190c-.59-3.92,2.22-7.32,6.66-7.94s8.07,1.88,8.57,5.83-2.35,7.25-6.67,7.85S108.25,193.92,107.65,190Zm12-1.69a4.39,4.39,0,1,0-3.76,4.82A4.16,4.16,0,0,0,119.61,188.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M137.43,179.53c.53,5.32.8,8,1.32,13.29l-2.62.26c-3.08-2.94-4.65-4.4-7.81-7.29.38,3.22.56,4.83.94,8.05l-3.15.37c-.65-5.3-1-8-1.61-13.25l2.7-.32c3.18,2.89,4.75,4.35,7.85,7.28-.33-3.22-.5-4.83-.84-8.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M140.78,179.21l3.27-.3L145,189.7c2.78-.24,4.17-.35,7-.57.08,1,.11,1.51.19,2.51-4.05.31-6.08.48-10.12.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M153,178.2c1.3-.1,2-.15,3.27-.23l.9,13.32-3.2.22C153.56,186.18,153.36,183.52,153,178.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M172.58,177.09c.22,5.33.32,8,.54,13.34l-2.63.11c-2.91-3.12-4.38-4.67-7.36-7.75.18,3.24.27,4.86.46,8.1l-3.17.18c-.32-5.33-.49-8-.82-13.32l2.71-.16c3,3.07,4.48,4.62,7.4,7.73-.14-3.24-.22-4.85-.36-8.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M187.08,187.56c0,1,0,1.48,0,2.47-4.29.07-6.43.13-10.72.28-.18-5.34-.28-8-.46-13.35,4.28-.14,6.42-.2,10.71-.27,0,1,0,1.49,0,2.48-3,.05-4.45.08-7.42.17l.08,2.9c2.61-.08,3.91-.11,6.52-.16,0,1,0,1.44,0,2.41-2.59,0-3.89.07-6.49.15,0,1.23.06,1.85.09,3.09C182.54,187.64,184.05,187.6,187.08,187.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M204.44,187.15c-2.59,0-3.88,0-6.47-.05L196.74,190h-3.29c2.45-5.36,3.69-8,6.25-13.35l3.24,0c2.47,5.37,3.68,8.06,6.05,13.45l-3.37-.06Zm-1-2.36c-.86-2-1.3-3.08-2.18-5.13-.91,2-1.36,3.06-2.25,5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M209.51,183.43c.09-4,3.43-6.84,7.84-6.69a7.41,7.41,0,0,1,5.72,2.6l-2.17,1.74a4.6,4.6,0,0,0-3.48-1.7,4.28,4.28,0,1,0-.3,8.54,4.55,4.55,0,0,0,3.56-1.45c.8.76,1.2,1.15,2,1.92a7.36,7.36,0,0,1-5.82,2.15C212.56,190.39,209.42,187.45,209.51,183.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M223.87,183.91c.19-4,3.6-6.75,8-6.49a7.45,7.45,0,0,1,5.66,2.74l-2.22,1.68a4.58,4.58,0,0,0-3.44-1.78,4.28,4.28,0,1,0-.5,8.53,4.56,4.56,0,0,0,3.59-1.36l1.94,2a7.35,7.35,0,0,1-5.87,2C226.76,191,223.69,187.93,223.87,183.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M238.22,184.75c.28-3.95,3.76-6.66,8.23-6.29s7.45,3.6,7.06,7.57-3.87,6.56-8.21,6.19S237.94,188.71,238.22,184.75Zm12,1a4.39,4.39,0,1,0-4.72,3.88A4.17,4.17,0,0,0,250.24,185.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M255.75,187.06c.3-3,.44-4.47.74-7.44l3.27.33c-.31,2.93-.47,4.4-.78,7.33-.26,2.52.77,3.68,2.71,3.9s3.21-.69,3.5-3.21c.34-2.93.51-4.39.86-7.31l3.22.38c-.37,3-.55,4.45-.91,7.42-.48,3.9-3.06,5.77-7,5.33S255.35,191,255.75,187.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M285.39,183.24c-.8,5.28-1.19,7.92-2,13.2l-2.61-.39c-2.28-3.6-3.44-5.4-5.79-9l-1.07,8-3.15-.41,1.7-13.25,2.69.35c2.37,3.59,3.54,5.39,5.83,9,.47-3.21.7-4.82,1.16-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M291.22,186.69c-1.78-.29-2.68-.43-4.47-.7.15-1,.23-1.49.38-2.49,4.9.75,7.34,1.15,12.23,2-.18,1-.26,1.49-.44,2.48l-4.46-.76c-.72,4.27-1.07,6.41-1.78,10.69-1.27-.22-1.91-.32-3.18-.52C290.19,193.11,290.54,191,291.22,186.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M301.1,185.81l3.24.58-2.41,13.13-3.17-.57C299.7,193.69,300.16,191.06,301.1,185.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M320.46,189.57c-1.11,5.22-1.66,7.84-2.77,13.06l-2.59-.54c-2.06-3.74-3.11-5.6-5.25-9.32l-1.55,7.95-3.12-.6c1-5.24,1.48-7.87,2.47-13.11l2.68.51c2.16,3.72,3.22,5.58,5.3,9.32.66-3.17,1-4.76,1.64-7.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M331.68,198.69l2.9.69c-.5,2.11-.75,3.16-1.26,5.27a10,10,0,0,1-5.88.36c-4.27-1-6.81-4.46-6-8.4s4.69-6.06,9.12-5a7.74,7.74,0,0,1,5.27,3.61l-2.47,1.29a4.91,4.91,0,0,0-3.24-2.3c-2.68-.62-4.9.67-5.45,3.15a4.25,4.25,0,0,0,3.5,5.17,5.53,5.53,0,0,0,2.59,0C331.14,201,331.32,200.22,331.68,198.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M140.18,214.35c.32-1,.49-1.45.81-2.42a8,8,0,0,0,4.54,1c1.82-.16,2.51-.83,2.44-1.65-.21-2.49-7.84-.06-8.33-5-.23-2.26,1.45-4.33,5.31-4.68a9.28,9.28,0,0,1,4.82.77c-.32,1-.47,1.45-.78,2.42a7.62,7.62,0,0,0-3.84-.72c-1.85.17-2.5.92-2.42,1.76.23,2.45,7.9.07,8.3,5,.18,2.22-1.51,4.26-5.3,4.6A9.67,9.67,0,0,1,140.18,214.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M152.09,207.91c-.31-4,2.61-7.14,6.91-7.42s7.6,2.48,7.81,6.46-2.74,7.05-6.91,7.32S152.4,211.86,152.09,207.91Zm11.56-.79a4.21,4.21,0,1,0-3.93,4.52A4.07,4.07,0,0,0,163.65,207.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M172.09,202.49l.15,3.53c2.49-.11,3.74-.15,6.24-.23,0,1,0,1.48.07,2.48-2.48.07-3.72.12-6.21.23.09,1.94.13,2.91.21,4.86l-3.08.14c-.26-5.34-.38-8-.64-13.34,4.11-.2,6.17-.28,10.29-.4,0,1,0,1.48.08,2.48C176.35,202.32,174.93,202.37,172.09,202.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M184.23,202.14l-4.34.11c0-1,0-1.51-.07-2.51,4.75-.14,7.12-.19,11.87-.23,0,1,0,1.51,0,2.52l-4.34.05c.07,4.34.11,6.5.18,10.84l-3.08.05C184.37,208.64,184.33,206.48,184.23,202.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M213.73,199.75c-1.94,5.28-2.89,7.93-4.75,13.23l-3.31-.06c-1.11-3.64-1.68-5.45-2.83-9.08-1.27,3.6-1.89,5.4-3.12,9h-3.29c-1.75-5.34-2.65-8-4.48-13.33h3.27c1.24,3.75,1.85,5.62,3,9.38,1.28-3.75,1.93-5.62,3.25-9.37l2.91,0c1.2,3.8,1.79,5.7,2.94,9.51,1.32-3.76,2-5.64,3.35-9.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M223.5,210.63c-2.48-.12-3.72-.17-6.21-.27L216,213.18l-3.16-.1c2.53-5.27,3.82-7.9,6.46-13.14l3.11.14c2.2,5.44,3.27,8.17,5.35,13.63l-3.23-.17C224.13,212.37,223.92,211.79,223.5,210.63Zm-.87-2.39c-.75-2.08-1.14-3.12-1.91-5.2-.94,2-1.41,3-2.34,5C220.08,208.12,220.93,208.16,222.63,208.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M237.62,214.35c-.91-1.56-1.37-2.34-2.3-3.9h-.16l-2.69-.17c-.1,1.48-.14,2.22-.24,3.71l-3.07-.19c.31-5.33.46-8,.77-13.33,2.36.14,3.53.21,5.89.37,3.63.25,5.76,2.28,5.53,5.27a4.37,4.37,0,0,1-3.09,4c1.08,1.8,1.61,2.7,2.66,4.51Zm-2.15-11-2.55-.16-.3,4.64,2.54.17c1.9.13,2.92-.68,3-2.12S237.39,203.46,235.47,203.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M253.63,213.26l-.25,2.46c-4.11-.41-6.16-.6-10.27-.95l1.1-13.3c4.11.34,6.16.53,10.27.94l-.25,2.47c-2.85-.29-4.27-.42-7.11-.67-.11,1.15-.16,1.73-.26,2.88,2.5.23,3.75.34,6.25.59-.1,1-.14,1.44-.24,2.39-2.49-.24-3.73-.36-6.22-.58-.11,1.23-.16,1.85-.27,3.08C249.28,212.82,250.73,213,253.63,213.26Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge3);
export default __webpack_public_path__ + "static/media/badge3.9e0316d5da8cd6f3a073a837db1a0bb1.svg";
export { ForwardRef as ReactComponent };